


























































import Vue from "vue";
import { store } from "@/store/store";
import { UserDataTable } from "@/types/types";
import CustomTable from "@/components/Table/table.vue";
import CustomCheckbox from "@/components/Input/Checkbox.vue";
import { DataTableHeader } from "vuetify/types";
import { User } from "@/store/modules/User/interface";

interface UserTableData {
  headers: Array<DataTableHeader>;
  items_displayed: Array<string>;
}

export default Vue.extend({
  name: "UserTable",
  components: { CustomTable, CustomCheckbox },
  props: {
    selected: {
      type: Array as () => Array<string>
    },
    shouldDisplayUpdateModal: {
      type: Function
    },
    shouldDisplayMailModal: {
      type: Function
    },
    shouldDisplayDeleteModal: {
      type: Function
    },
    onSelectChange: {
      type: Function
    },
    searchFilter: {
      type: Object
    }
  },
  data: (): UserTableData => {
    return {
      headers: [
        { text: "", value: "selected", sortable: false },
        { text: "Email", align: "start", value: "mail" },
        { text: "Agence", value: "agence" },
        { text: "Role", value: "role" },
        { text: "actions", value: "actions", sortable: false, width: "15%" }
      ],
      items_displayed: []
    };
  },
  methods: {
    format_data(): Array<UserDataTable> {
      const user_by_id = store.getters.USER_ALL_ID;
      return user_by_id.map((user_id: string): UserDataTable => {
        let user: UserDataTable = { ...store.getters.USER_BY_ID[user_id] };
        user.role = store.getters.ROLE_BY_ID[store.getters.USER_BY_ID[user_id].role].name;
        user.agence = store.getters.AGENCE_BY_ID[store.getters.USER_BY_ID[user_id].agence].name;
        return user;
      });
    },
    userGotRight(_id: string): boolean {
      const user = store.getters.USER_BY_ID[_id];
      if (this.isAdmin() || store.getters.ROLE_BY_ID[user.role].name.toUpperCase() !== "ADMIN") {
        return true;
      }
      return false;
    },
    is_actual_user(_id: string) {
      return store.getters.LOGGED_USER?._id !== _id;
    },
    CheckIfSelected(_id: string): boolean {
      return this.selected.findIndex((selected_item) => selected_item === _id) !== -1;
    },
    selectedToggleAll(selected: boolean): void {
      this.onSelectChange(
        selected ? [...this.items_displayed].filter((user_id) => user_id !== store.getters.LOGGED_USER?._id) : []
      );
    },
    selectedChange(_id: string): void {
      let selected_copy = [...this.selected];
      const found_id = selected_copy.findIndex((select: string) => select === _id);
      found_id !== -1 ? selected_copy.splice(found_id, 1) : selected_copy.push(_id);
      this.onSelectChange(selected_copy);
    },
    currentItems(items: Array<any>) {
      this.items_displayed = items.map((item) => item._id) as Array<string>;
    },
    customFilter(value: string | undefined, search: string, item: any) {
      const search_ = JSON.parse(search);
      return ![
        this.agenceFilter(search_.agence, item.agence),
        this.roleFilter(search_.role, item.role),
        this.mailFilter(search_.mail, item.mail)
      ].includes(false);
    },
    agenceFilter(agence: string | null, item: string): boolean {
      return agence === "" || agence === null ? true : agence === item ? true : false;
    },
    roleFilter(role: string | null, item: string): boolean {
      return role === "" || role === null ? true : role === item ? true : false;
    },
    mailFilter(mail: string | null, item: string): boolean {
      if (mail === "" || mail === null) return true;
      return item.toLowerCase().indexOf(mail.toLowerCase().trim()) !== -1 ? true : false;
    },
    isAdmin(): boolean {
      const user = store.getters.LOGGED_USER as User;
      return store.getters.ROLE_BY_ID[user.role].name.toUpperCase() === "ADMIN" ? true : false;
    }
  }
});
